import storage from './storage';

// Called from background and injection
export default async function on401() {
  await storage.set({
    connectionStatus: 'no-auth',
    authKey: null,
  });
}
